'use client';
import {FormControl, FormHelperText, TextField} from '@mui/material';
import {useEffect} from 'react';
import {Controller} from 'react-hook-form';

export const RHFTextField = ({
  name,
  control,
  label,
  error,
  setValue,
  fieldValue,
  variant,
  mb = 3,
  required = true,
  ...other
}) => {
  return (
    <FormControl fullWidth sx={{mb}}>
      <Controller
        name={name}
        control={control}
        rules={{required}}
        render={({field: {value, onChange}}) => (
          <TextField
            label={label}
            variant={variant}
            value={fieldValue || value}
            InputLabelProps={{shrink: !!(fieldValue || value)}}
            onChange={onChange}
            onBlur={(e) => onChange(e.target.value.trim())}
            {...other}
          />
        )}
      />
      {error && (
        <FormHelperText sx={{color: 'error.main', ml: -0.01, mt: 2}}>
          {error.message}
        </FormHelperText>
      )}
    </FormControl>
  );
};
